/**
 * @packageDocumentation
 * @module f1/string
 */

export interface Prefix {
  /**
   * Append a prefix to a string
   *
   * @public
   * @function f1.prefix
   * @param prefix the string to place before `s`
   * @param s any string
   * @example
   *
   * ```ts
   * f1.prefix('hi', 'there') === 'hithere'
   * ```
   */
  (prefix: string, s: string): string;
  (prefix: string): (s: string) => string;
}

/**
 * @see Prefix
 */
export default (prefix: string, s: string) => {
  return `${prefix}${s}`;
};
